import Vue from 'vue'
import Vuex from 'vuex'
import config from '../unit/index'
import search from './modules/search'

Vue.use(Vuex);

const state = {
  nav: 1,
  keyword: ''
};
const mutations = {
  setNav (state, n) {
    state.nav = n;
  }
};

export default new Vuex.Store({
  state,
  mutations,
  modules: {
    search
  },
  strict: config.env === 'development',
})



// WEBPACK FOOTER //
// ./src/store/index.js